/**
 * LanguageSwitcher - Portal wrapper around lib's LanguageSwitcher.
 *
 * Holds the hardcoded list of supported portal languages and wires the
 * onChange callback through `/switch-language` via `navigatePortalInternal`.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher as LibLanguageSwitcher, type Language } from '@/components/ui';
import { navigatePortalInternal } from '../PortalLayout/PortalLayout.store';
import type { LanguageSwitcherProps } from './LanguageSwitcher.types';

const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en-US', label: 'EN', flagSrc: '/img/flags/us.svg' },
  { code: 'vi-VN', label: 'VI', flagSrc: '/img/flags/vn.svg' },
];

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (langCode: string) => {
    if (langCode === i18n.language) return;
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    navigatePortalInternal(`/switch-language?culture=${langCode}&returnUrl=${returnUrl}`);
  };

  return (
    <LibLanguageSwitcher
      languages={SUPPORTED_LANGUAGES}
      currentLang={i18n.language}
      onChange={handleLanguageChange}
      className={className}
    />
  );
};

LanguageSwitcher.displayName = 'LanguageSwitcher';
